import { yup } from '@guiker/shared-framework'

import { RentChargeType } from '../../../../entity'

export const createRentCharge = yup.object({
  chargeDate: yup.string().required(),
  type: yup.string().oneOf(Object.values(RentChargeType)).required(),
})
